"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/message/v1/portal_common.proto (package spwn.message.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalMessageUnselectedThread = exports.PortalMessageThread = exports.PortalMessageChatPartner = exports.PortalMessageDmMessageForGet = exports.PortalMessageDmMessage = exports.PortalMessageDmMessageDeleted = exports.PortalMessageDmMessageTextWithFile = exports.PortalMessageDmMessageFile = exports.PortalMessageDmMessageText = exports.PortalMessageDmMessageBody = exports.PortalMessageSender = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * DMのメッセージを送ったのがファン(user)かクリエイター(brand)か
 *
 * @generated from enum spwn.message.v1.PortalMessageSender
 */
var PortalMessageSender;
(function (PortalMessageSender) {
    /**
     * @generated from enum value: PORTAL_MESSAGE_SENDER_UNSPECIFIED = 0;
     */
    PortalMessageSender[PortalMessageSender["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * ファン(user)がメッセージを送った
     *
     * @generated from enum value: PORTAL_MESSAGE_SENDER_USER = 1;
     */
    PortalMessageSender[PortalMessageSender["USER"] = 1] = "USER";
    /**
     * クリエイター(brand)がメッセージを送った
     *
     * @generated from enum value: PORTAL_MESSAGE_SENDER_BRAND = 2;
     */
    PortalMessageSender[PortalMessageSender["BRAND"] = 2] = "BRAND";
})(PortalMessageSender = exports.PortalMessageSender || (exports.PortalMessageSender = {}));
// Retrieve enum metadata with: proto3.getEnumType(PortalMessageSender)
protobuf_1.proto3.util.setEnumType(PortalMessageSender, "spwn.message.v1.PortalMessageSender", [
    { no: 0, name: "PORTAL_MESSAGE_SENDER_UNSPECIFIED" },
    { no: 1, name: "PORTAL_MESSAGE_SENDER_USER" },
    { no: 2, name: "PORTAL_MESSAGE_SENDER_BRAND" },
]);
/**
 * @generated from message spwn.message.v1.PortalMessageDmMessageBody
 */
class PortalMessageDmMessageBody extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof spwn.message.v1.PortalMessageDmMessageBody.body
         */
        this.body = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageDmMessageBody().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageDmMessageBody().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageDmMessageBody().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageDmMessageBody, a, b);
    }
}
exports.PortalMessageDmMessageBody = PortalMessageDmMessageBody;
PortalMessageDmMessageBody.runtime = protobuf_1.proto3;
PortalMessageDmMessageBody.typeName = "spwn.message.v1.PortalMessageDmMessageBody";
PortalMessageDmMessageBody.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "text", kind: "message", T: PortalMessageDmMessageText, oneof: "body" },
    { no: 2, name: "file", kind: "message", T: PortalMessageDmMessageFile, oneof: "body" },
    { no: 3, name: "text_with_file", kind: "message", T: PortalMessageDmMessageTextWithFile, oneof: "body" },
    { no: 4, name: "deleted", kind: "message", T: PortalMessageDmMessageDeleted, oneof: "body" },
]);
/**
 * @generated from message spwn.message.v1.PortalMessageDmMessageText
 */
class PortalMessageDmMessageText extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string content = 1;
         */
        this.content = "";
        /**
         * メッセージをpostする時にはlink, getする時には, iframelyで生成されたhtmlが入る
         *
         * @generated from field: repeated string ogp_cark_link_or_html = 2;
         */
        this.ogpCarkLinkOrHtml = [];
        /**
         * messageをhtmlにレンダリングしたもの. お知らせメールで使用
         *
         * @generated from field: string html_content = 3;
         */
        this.htmlContent = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageDmMessageText().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageDmMessageText().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageDmMessageText().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageDmMessageText, a, b);
    }
}
exports.PortalMessageDmMessageText = PortalMessageDmMessageText;
PortalMessageDmMessageText.runtime = protobuf_1.proto3;
PortalMessageDmMessageText.typeName = "spwn.message.v1.PortalMessageDmMessageText";
PortalMessageDmMessageText.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ogp_cark_link_or_html", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "html_content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.message.v1.PortalMessageDmMessageFile
 */
class PortalMessageDmMessageFile extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string file_url = 1;
         */
        this.fileUrl = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageDmMessageFile().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageDmMessageFile().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageDmMessageFile().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageDmMessageFile, a, b);
    }
}
exports.PortalMessageDmMessageFile = PortalMessageDmMessageFile;
PortalMessageDmMessageFile.runtime = protobuf_1.proto3;
PortalMessageDmMessageFile.typeName = "spwn.message.v1.PortalMessageDmMessageFile";
PortalMessageDmMessageFile.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "file_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.message.v1.PortalMessageDmMessageTextWithFile
 */
class PortalMessageDmMessageTextWithFile extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string content = 1;
         */
        this.content = "";
        /**
         * @generated from field: string file_url = 2;
         */
        this.fileUrl = "";
        /**
         * メッセージをpostする時にはlink, getする時には, iframelyで生成されたhtmlが入る
         *
         * @generated from field: repeated string ogp_cark_link_or_html = 3;
         */
        this.ogpCarkLinkOrHtml = [];
        /**
         * messageをhtmlにレンダリングしたもの. お知らせメールで使用
         *
         * @generated from field: string html_content = 4;
         */
        this.htmlContent = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageDmMessageTextWithFile().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageDmMessageTextWithFile().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageDmMessageTextWithFile().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageDmMessageTextWithFile, a, b);
    }
}
exports.PortalMessageDmMessageTextWithFile = PortalMessageDmMessageTextWithFile;
PortalMessageDmMessageTextWithFile.runtime = protobuf_1.proto3;
PortalMessageDmMessageTextWithFile.typeName = "spwn.message.v1.PortalMessageDmMessageTextWithFile";
PortalMessageDmMessageTextWithFile.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "file_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ogp_cark_link_or_html", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "html_content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.message.v1.PortalMessageDmMessageDeleted
 */
class PortalMessageDmMessageDeleted extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageDmMessageDeleted().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageDmMessageDeleted().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageDmMessageDeleted().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageDmMessageDeleted, a, b);
    }
}
exports.PortalMessageDmMessageDeleted = PortalMessageDmMessageDeleted;
PortalMessageDmMessageDeleted.runtime = protobuf_1.proto3;
PortalMessageDmMessageDeleted.typeName = "spwn.message.v1.PortalMessageDmMessageDeleted";
PortalMessageDmMessageDeleted.fields = protobuf_1.proto3.util.newFieldList(() => []);
/**
 * @generated from message spwn.message.v1.PortalMessageDmMessage
 */
class PortalMessageDmMessage extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string dm_message_id = 1;
         */
        this.dmMessageId = "";
        /**
         * @generated from field: string user_id = 2;
         */
        this.userId = "";
        /**
         * @generated from field: string brand_id = 3;
         */
        this.brandId = "";
        /**
         * @generated from field: spwn.message.v1.PortalMessageSender sender = 4;
         */
        this.sender = PortalMessageSender.UNSPECIFIED;
        /**
         * @generated from field: int64 created_at = 5;
         */
        this.createdAt = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageDmMessage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageDmMessage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageDmMessage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageDmMessage, a, b);
    }
}
exports.PortalMessageDmMessage = PortalMessageDmMessage;
PortalMessageDmMessage.runtime = protobuf_1.proto3;
PortalMessageDmMessage.typeName = "spwn.message.v1.PortalMessageDmMessage";
PortalMessageDmMessage.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "dm_message_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "sender", kind: "enum", T: protobuf_1.proto3.getEnumType(PortalMessageSender) },
    { no: 5, name: "created_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "body", kind: "message", T: PortalMessageDmMessageBody },
]);
/**
 * @generated from message spwn.message.v1.PortalMessageDmMessageForGet
 */
class PortalMessageDmMessageForGet extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int64 created_at = 1;
         */
        this.createdAt = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageDmMessageForGet().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageDmMessageForGet().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageDmMessageForGet().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageDmMessageForGet, a, b);
    }
}
exports.PortalMessageDmMessageForGet = PortalMessageDmMessageForGet;
PortalMessageDmMessageForGet.runtime = protobuf_1.proto3;
PortalMessageDmMessageForGet.typeName = "spwn.message.v1.PortalMessageDmMessageForGet";
PortalMessageDmMessageForGet.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "created_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "body", kind: "message", T: PortalMessageDmMessageBody },
]);
/**
 * @generated from message spwn.message.v1.PortalMessageChatPartner
 */
class PortalMessageChatPartner extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * @generated from field: string avatar_url = 3;
         */
        this.avatarUrl = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageChatPartner().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageChatPartner().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageChatPartner().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageChatPartner, a, b);
    }
}
exports.PortalMessageChatPartner = PortalMessageChatPartner;
PortalMessageChatPartner.runtime = protobuf_1.proto3;
PortalMessageChatPartner.typeName = "spwn.message.v1.PortalMessageChatPartner";
PortalMessageChatPartner.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "avatar_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.message.v1.PortalMessageThread
 */
class PortalMessageThread extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.message.v1.PortalMessageDmMessage dm_messages = 1;
         */
        this.dmMessages = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageThread().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageThread().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageThread().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageThread, a, b);
    }
}
exports.PortalMessageThread = PortalMessageThread;
PortalMessageThread.runtime = protobuf_1.proto3;
PortalMessageThread.typeName = "spwn.message.v1.PortalMessageThread";
PortalMessageThread.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "dm_messages", kind: "message", T: PortalMessageDmMessage, repeated: true },
    { no: 2, name: "chat_partner", kind: "message", T: PortalMessageChatPartner },
]);
/**
 * @generated from message spwn.message.v1.PortalMessageUnselectedThread
 */
class PortalMessageUnselectedThread extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool is_unread = 3;
         */
        this.isUnread = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalMessageUnselectedThread().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalMessageUnselectedThread().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalMessageUnselectedThread().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalMessageUnselectedThread, a, b);
    }
}
exports.PortalMessageUnselectedThread = PortalMessageUnselectedThread;
PortalMessageUnselectedThread.runtime = protobuf_1.proto3;
PortalMessageUnselectedThread.typeName = "spwn.message.v1.PortalMessageUnselectedThread";
PortalMessageUnselectedThread.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "dm_messages", kind: "message", T: PortalMessageDmMessage },
    { no: 2, name: "chat_partner", kind: "message", T: PortalMessageChatPartner },
    { no: 3, name: "is_unread", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
//# sourceMappingURL=portal_common_pb.js.map